import React, { ReactNode } from 'react';
import styled from 'styled-components';

import BoxGradientBorder from '../../../../../components/BoxGradientBorder';

const Wrapper = styled(BoxGradientBorder)`
  border-radius: 0.6em;

  --BoxGradientBorder-width: 1px;
  --BoxGradientBorder-gradient: linear-gradient(12deg, rgba(255, 255, 255, 0) 36%, rgba(255, 255, 255, 0.5) 80%);
  --BoxGradientBorder-fallbackColor: rgba(255, 255, 255, 0.25);
  background-image: linear-gradient(to top, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0) 35%);
`;

type MissionBoxWrapperProps = {
  className?: string;
  children?: ReactNode;
};

const MissionBoxWrapper = ({ className = '', children }: MissionBoxWrapperProps) => {
  return <Wrapper className={className}>{children}</Wrapper>;
};

export default MissionBoxWrapper;
